// aotoken/src/app.js
import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import { HeaderToken, Footer, WalletProvider } from "@dsc/ui/token";
import "@dsc/ui/header.css";

// Pages / Components
import AotokenCollection from "./components/tokens/AotokenCollection";
import ProposeTokenMint from "./components/tokens/ProposeTokenMint";
import ManageMultisig from "./components/multisig/ManageMultisig";
import ApproveMintRequest from "./components/multisig/ApproveMintRequest";
import LoadAotoken from "./components/tokens/LoadAotoken";
import TokenDetail from "./components/tokens/TokenDetail";

console.log("🧠 UI Imports →", { HeaderToken, Footer, WalletProvider });

const App = () => {
  return (
    // ✅ WalletProvider wraps everything that uses WalletContext (Header, ManageMultisig, etc.)
    <WalletProvider>
      <Router>
        {/* Shared header */}
        <HeaderToken appType="aotoken" height="30px" />

        <div className="container" style={{ padding: "20px" }}>
          <Routes>
            {/* 🏠 Home page */}
            <Route
              path="/"
              element={
                <div className="home" style={{ textAlign: "left", padding: "20px 20px" }}>
                  <h2>Welcome to the digital authorisation and licence Page!</h2>
                  <p>Select an option from the navigation bar to get started.</p>
                </div>
              }
            />

            {/* 🔹 Token routes */}
            <Route path="/aotoken-collection" element={<AotokenCollection />} />
            <Route path="/manage-multisig" element={<ManageMultisig />} />

            {/* Mint AoToken toolkit section */}
            <Route
              path="/mint-aotoken"
              element={
                <div>
                  <h2>Mint AoToken</h2>
                  <ul>
                    <li>
                      <Link to="/manage-multisig">Manage Multisig</Link>
                    </li>
                    <li>
                      <Link to="/propose-token-mint">Propose Licence</Link>
                    </li>
                  </ul>
                </div>
              }
            />

            <Route path="/propose-token-mint" element={<ProposeTokenMint />} />
            <Route path="/approve-mint-request" element={<ApproveMintRequest />} />
            <Route path="/load-aotoken" element={<LoadAotoken />} />
            <Route path="/tokens/:tokenId" element={<TokenDetail />} />

            {/* 🚫 Fallback 404 */}
            <Route path="*" element={<div>404 — Page Not Found</div>} />
          </Routes>
        </div>

        {/* Shared footer */}
        <Footer />
      </Router>
    </WalletProvider>
  );
};

export default App;